<!--suppress AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="javascript:void(0);">
      <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </a></li>
    <li class="breadcrumb-item"><a href="javascript:void(0);" translate>Orders</a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>New Order</li>
    <li class="breadcrumb-item">
      <a href="https://www.youtube.com/watch?v=ajQAeuuaSOE" target="_blank">
        <svg width="15" height="15" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
          <g id="Group">
            <path id="Path" fill="#06209f" stroke="none"
                  d="M 683.015686 117.331543 C 526.902344 -38.973694 273.638733 -39.129089 117.331566 116.982361 C -38.973663 273.097717 -39.130989 526.363159 116.984306 682.670349 C 273.095764 838.975586 526.36322 839.130981 682.670349 683.017639 C 838.973694 526.906128 839.130981 273.636841 683.015686 117.331543 Z M 455.850311 653.819031 C 455.850311 659.991028 450.848602 664.988892 444.68042 664.988892 L 355.321472 664.988892 C 349.15332 664.988892 344.151642 659.991028 344.151642 653.819031 L 344.151642 322.097748 C 344.151642 315.925751 349.15332 310.927887 355.321472 310.927887 L 444.68042 310.927887 C 450.848602 310.927887 455.850311 315.923828 455.850311 322.097748 L 455.850311 653.819031 Z M 400.000977 264.571594 C 364.281158 264.571594 335.218811 235.513062 335.218811 199.791382 C 335.218811 164.073486 364.279266 135.009216 400.000977 135.009216 C 435.722656 135.009216 464.783112 164.071594 464.783112 199.791382 C 464.783112 235.513062 435.718811 264.571594 400.000977 264.571594 Z"/>
          </g>
          <g id="g1"/>
        </svg>
      </a>
    </li>
  </ol>
</nav>
<div *ngIf="!loading && myBusiness && formStatus == 'new'" class="content-section bg-white p-3 border-light animated animatedFadeInUp fadeInUp">
  <div class="row inv--head-section">
    <div class="col-sm-6 col-12">
      <h3 class="in-heading" translate>NEW INVOICE</h3>
    </div>
  </div>
  <form novalidate action="javascript:void(0)">
    <!-- Client name and from section -->
    <div class="row inv--detail-section p-1">
      <!-- Client name -->
      <div class="col-2 align-self-start">
        <div class="inv-customer-name">
          <label for="name" translate>Client Name</label>
          <div class="input-group input-group-sm">
            <input type="text" class="form-control" [(ngModel)]="clientName" id="name" name="name" placeholder="{{'' | translate}}">
          </div>
        </div>
      </div>
      <div class="col-2 align-self-start d-none">
        <div class="inv-customer-name">
          <label for="currency" translate>Currency</label>
          <div class="input-group input-group-sm">
            <select type="text" class="form-control" style="padding:0" [(ngModel)]="currency" id="currency" name="currency">
              <option value='SAR' translate>Saudi Riyal (<img src="assets/sr.svg" height="18"/> )</option>
              <option value='USD' translate>US Dollar</option>
              <option value='EUR' translate>EURO</option>
              <option value='GBP' translate>British Pound</option>
            </select>
          </div>
        </div>
      </div>
      <!-- end of Client name -->
      <!-- From section -->
      <div class="col-3 offset-5 align-self-start">
        <img alt="merchant image" [src]="env.getRest() + '/openApi/loadMerchantImage/' + myBusiness.id + '/80/80'" style="max-width: 180px"/>
        <p class="inv-detail-title m-1" style="white-space: nowrap">{{ 'From' | translate }} : {{ myBusiness.businessName }}</p>
        <p class="inv-created-date" style="white-space: nowrap">{{ 'Invoice Date' | translate }} : {{ today }}</p>
      </div>
      <!-- end of From section -->
    </div>
    <!-- End of Client name and from section -->
    <div class="row mx-3 my-3 mt-5">
      <div class="col-2">
        <a href="javascript:void(0);" (click)="showAddProductModal()" translate>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="16"></line>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
          {{ 'Add Product' | translate }}
        </a>
      </div>
      <div class="col">
        <!--        <a href="javascript:void(0);" data-toggle="modal" [attr.data-target]="'#addCustomModal'" translate>-->
        <a href="javascript:void(0);" (click)="showAddCustomModal()" translate>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="16"></line>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
          {{ 'Add Custom Product' | translate }}
        </a>
      </div>
    </div>
    <div class="row inv--product-table-section my-1">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table">
            <thead class="">
            <tr>
              <th scope="col" translate>S.No</th>
              <th scope="col" translate>Items</th>
              <th class="text-left" scope="col" translate>Qty</th>
              <th class="text-left" scope="col" translate>Price</th>
              <th class="text-left" scope="col" translate>Amount</th>
              <th class="text-left" scope="col" translate></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let po of productOrders;let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ po.title }}</td>
              <td>{{ po.qty }}</td>
              <td>{{ po.price }}</td>
              <td>{{ po.qty && po.price ? po.qty * po.price : '' }}</td>
              <td>
                <a href="javascript:void(0);" data-toggle="modal" (click)="removeProduct(po)" translate>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                  </svg>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-sm-6 col-12 order-sm-0 order-1">
        <div class="inv--payment-info">
          <div class="row my-1">
            <div class="col-sm-5 col-12">
              <p>{{ 'Sub-Total:' | translate }} </p>
            </div>
            <div class="col-sm-7 col-12">
              <p class="">{{ subtotal }} <span [innerHTML]="currency == 'SAR' ? srSvg : currency | translate"></span></p>
            </div>
            <div class="col-sm-5 col-12">
              <p class=" inv-subtitle">{{ 'Discount:' | translate }} </p>
            </div>
            <div class="col-sm-7 col-12 input-group input-group-sm">
              <input style="max-width: 100px" type="text" class="form-control" id="discount" [(ngModel)]="discount" name="discount" placeholder="{{'Discount' | translate}}" aria-label="discount" aria-describedby="discountIcon">
              <div class="input-group-append">
                <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false"><span [innerHTML]="(discountType == 'SAR' ? (currency == 'SAR' ? srwSvg : currency) : discountType) | translate"></span></button>
                <div class="dropdown-menu">
                  <a class="dropdown-item" href="javascript:void(0);" (click)="changeDiscountType('%')">%</a>
                  <a class="dropdown-item" href="javascript:void(0);" (click)="changeDiscountType('SAR')">{{ (currency == 'SAR' ? srSvg : currency) | translate }}</a>
                </div>
              </div>
            </div>
            <div *ngIf="myBusiness && myBusiness.vatNumber" class="col-sm-5 col-12">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" name="vat" [(ngModel)]="vat" class="custom-control-input" id="vat">
                <label class="custom-control-label" for="vat">{{ 'VAT' | translate }} ({{ myBusiness.vatPercent * 100 }}%)</label>
              </div>
            </div>
            <div *ngIf="myBusiness && myBusiness.vatNumber" class="col-sm-7 col-12">
              <p class="">{{ vatAmount | number:'1.2-2' }} <span [innerHTML]="(currency == 'SAR' ? srSvg : currency) | translate"></span></p>
            </div>
            <div class="col-sm-5 col-12 grand-total-title">
              <h4 class="">{{ 'Total' | translate }} : </h4>
            </div>
            <div class="col-sm-7 col-12 grand-total-amount">
              <h4 class="">{{ total | number:'1.2-2' }} <span [innerHTML]="(currency == 'SAR' ? srSvg : currency) | translate"></span></h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2 p-3">
      <div class="form-group w-100">
        <label for="order-note" translate>Note</label>
        <textarea name="order-note" [(ngModel)]="orderNote" class="form-control" id="order-note" rows="3"></textarea>
      </div>
    </div>

<!--    <div class="row mt-2">-->
<!--      <div class="col-12">-->
<!--        <input type="checkbox" name="agreement" [(ngModel)]="agreement" id="agreement" class="mr-2">-->
<!--        <label for="agreement" translate>Request the client to approve an agreement file?</label>-->
<!--      </div>-->
<!--      <div class="col-12 agreement-dropzone" [hidden]="!agreement" #agreementDropzone>-->
<!--   todo: complete the upload document zone here     -->
<!--      </div>-->
<!--    </div>-->

    <div class="row mt-2" *ngIf="myBusiness.canSendSms">
      <div class="col-12">
        <input type="checkbox" name="sendSmsChecked" [(ngModel)]="sendSmsChecked" id="sendSmsChecked" class="mr-2">
        <label for="sendSmsChecked" translate>Send SMS to Client</label>
      </div>

      <div class="col-4">
        <div class="form-group m-3" [hidden]="!sendSmsChecked">
          <label for="sendSmsPhone" translate>Phone</label>
          <div id="urpay-otp-input-div" class="w-100">
            <input #sendSmsPhoneElm class="form-control" id="sendSmsPhone" name="sendSmsPhone" type="tel" [(ngModel)]="sendSmsPhone" [ngClass]="{ 'is-invalid': sendSmsPhoneErrors }"/>
            <div *ngIf="sendSmsPhoneErrors" class="invalid-feedback" style="display: block;">
            </div>
          </div>
        </div>
      </div>

      <div class="form-group w-100 m-3" [hidden]="!sendSmsChecked">
        <label for="sendSmsContent" translate>SMS Content</label>
        <div class="form-control p-3 border" style="min-height: 150px" id="sendSmsContent">
          عزيزي/عزيزتي
          {{ clientName ?? '&#123;اسم الزبون&#125;' }}
          ، لديك فاتورة جديدة من {{ this.myBusiness.businessName }} برقم
          &#123;رقم الفاتورة&#125;. للتفاصيل والدفع
          &#123;رابط دفع الفاتورة&#125;.
        </div>
      </div>

    </div>

    <button *ngIf="!loadingBtn" class="btn btn-primary mt-2" type="submit" (click)="submitForm()" translate>Submit</button>
    <button *ngIf="loadingBtn" class="btn btn-primary mt-2" type="submit" disabled translate>Please wait</button>
  </form>
</div>
<!-- ************************************************************************************************************** -->
<!-- **                                       Add new product modal                                              ** -->
<!-- ************************************************************************************************************** -->
<div class="modal fade" id="addModal" tabindex="-1" role="dialog" aria-labelledby="addModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addModalLabel">{{ 'Add Product' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">x</button>
      </div>
      <div class="modal-body">
        <app-product-update [hasSubscribers]='true' (close)="closeModal()" (product)="productSelected($event)"></app-product-update>
      </div>
    </div>
  </div>
</div>
<!-- ************************************************************************************************************** -->
<!-- **                                       Add custom product modal                                              ** -->
<!-- ************************************************************************************************************** -->
<div class="modal fade" id="addCustomModal" tabindex="-1" role="dialog" aria-labelledby="addCustomModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addCustomModalLabel">{{ 'Add Custom Product' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">x</button>
      </div>
      <div class="modal-body">
        <app-product-widget (product)="productSelected($event)" (close)="closeModal()"></app-product-widget>
      </div>
    </div>
  </div>
</div>
<!-- ************************************************************************************************************** -->
<!-- **                                       Loading Panel                                                      ** -->
<!-- ************************************************************************************************************** -->
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
<!-- ************************************************************************************************************** -->
<!-- **                                       Order Created Panel                                                ** -->
<!-- ************************************************************************************************************** -->
<div *ngIf="!loading && formStatus == 'created'">
  <div class="w-50 mx-auto statbox widget box box-shadow content-section bg-white p-3 border-light animated animatedFadeInUp fadeInUp">
    <div class="widget-header p-3">
      <div class="row">
        <div class="col-xl-12 col-md-12 col-sm-12 col-12">
          <h4 translate>Order created</h4>
        </div>
      </div>
    </div>
    <div class="widget-content widget-content-area p-3 text-success">
      {{ 'Order has been created with order number' | translate }}: {{ newOrderNumber }}
    </div>
    <div class="p-3">
      <a href="javascript:void(0);" data-toggle="modal" (click)="shareLink()" translate>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-share-2">
          <circle cx="18" cy="5" r="3"></circle>
          <circle cx="6" cy="12" r="3"></circle>
          <circle cx="18" cy="19" r="3"></circle>
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
        </svg>
        {{ 'Share Link' | translate }}
      </a>
      <a href="javascript:void(0);" data-toggle="modal" (click)="newOrder()" translate>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-file-text">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
        {{ 'New Order' | translate }}
      </a>
    </div>
  </div>
</div>
<app-share-panel [link]="orderShareLink" modalId="orderShareLink"></app-share-panel>
